import {
  TICKET_LIST,
  ALL_TICKET_LIST,
  SINGLE_CATEGORY_TICKET_LIST,
  ALL_COUPON_LIST,
  COUPON_LIST,
  EDIT_COUPON,
  EDIT_TICKET,
  SETTING_DATA,
  ORDER_LIST,
  STRIPE_ACCOUNT_DATA,
  TICKET_MODAL,
  TICKET_DASHBOARD_STATUS,
  TICKET_URL_MODAL,
  TICKET_ORDER_URL_MODAL,
  ORDER_TICKET_MODAL,
  DEFAULT_TERMS_MODAL,
  STRIPE_CURRENCY,
  WIZARD_STEP,
  SALES_REPORT_EXPORT_MODAL,
  SALES_ORDER_REFUND_MODAL,
  PAYMENT_GATEWAY_INFO_MODAL,
  TICKET_SEND_LIST,
  CLIENT_CARD_INFO_MODAL,
  TICKET_SESSION_MODAL,
  TICKET_SORTBY_MODAL,
} from "TicketAction";

export function TicketList(state = {}, action) {
  switch (action.type) {
    case TICKET_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function allTicketList(state = {}, action) {
  switch (action.type) {
    case ALL_TICKET_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function siglrCategoryTicketList(state = {}, action) {
  switch (action.type) {
    case SINGLE_CATEGORY_TICKET_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function EditTicket(state = {}, action) {
  switch (action.type) {
    case EDIT_TICKET:
      return action.payload;
    default:
      return state;
  }
}

export function allCouponList(state = {}, action) {
  switch (action.type) {
    case ALL_COUPON_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function CouponList(state = {}, action) {
  switch (action.type) {
    case COUPON_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function EditCoupon(state = {}, action) {
  switch (action.type) {
    case EDIT_COUPON:
      return action.payload;
    default:
      return state;
  }
}

export function SettingData(state = {}, action) {
  switch (action.type) {
    case SETTING_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function OrderList(state = {}, action) {
  switch (action.type) {
    case ORDER_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function StripeAccountData(state = {}, action) {
  switch (action.type) {
    case STRIPE_ACCOUNT_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function showTicketModal(state = {}, action) {
  switch (action.type) {
    case TICKET_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function ticketDashboard(state = {}, action) {
  switch (action.type) {
    case TICKET_DASHBOARD_STATUS:
      return action.payload;
    default:
      return state;
  }
}

export function showTicketUrlModal(state = {}, action) {
  switch (action.type) {
    case TICKET_URL_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function showTicketOrderUrlModal(state = {}, action) {
  switch (action.type) {
    case TICKET_ORDER_URL_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function showOrderTicketModal(state = {}, action) {
  switch (action.type) {
    case ORDER_TICKET_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function showDefaultTermsModal(state = {}, action) {
  switch (action.type) {
    case DEFAULT_TERMS_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function stripeCurrencyDetailsList(state = {}, action) {
  switch (action.type) {
    case STRIPE_CURRENCY:
      return action.payload;
    default:
      return state;
  }
}

export function WizardStep(state = {}, action) {
  switch (action.type) {
    case WIZARD_STEP:
      return action.payload;
    default:
      return state;
  }
}

export function ShowSalesReportExportModal(state = {}, action) {
  switch (action.type) {
    case SALES_REPORT_EXPORT_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function refundModalShow(state = {}, action) {
  switch (action.type) {
    case SALES_ORDER_REFUND_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function paymentGatewayModal(state = {}, action) {
  switch (action.type) {
    case PAYMENT_GATEWAY_INFO_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function clientCardInfoModal(state = {}, action) {
  switch (action.type) {
    case CLIENT_CARD_INFO_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function ticketSendList(state = {}, action) {
  switch (action.type) {
    case TICKET_SEND_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function ticketSesionModal(state = {}, action) {
  switch (action.type) {
    case TICKET_SESSION_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function ticketSortbyModal(state = {}, action) {
  switch (action.type) {
    case TICKET_SORTBY_MODAL:
      return action.payload;
    default:
      return state;
  }
}
